import { ContactFormData } from 'containers/rough-work/types';

/**
 * Форматирует телефонный номер, удаляя из него все символы, кроме цифр.
 *
 * @param {string} phone - телефонный номер, который нужно отформатировать.
 *
 * @returns {string} отформатированный телефонный номер, содержащий только цифры.
 */

export const formatPhone = (phone: string) => {
	return phone.replace(/[^0-9]/g, '');
};

/**
 * Форматирует данные формы.
 *
 * @param {ContactFormData} formData - данные формы.
 *
 * @returns {ContactFormData} отформатированные данные формы.
 *
 * @remarks
 * Функция форматирует поле 'phone' - удаляет из него все символы, кроме цифр,
 * и возвращает отформатированные данные формы.
 */
export const formatFormData = (formData: ContactFormData) => {
	return {
		...formData,
		phone: formatPhone(formData.phone),
	};
};
